/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React from "react";


import DefaultMessageComponent from "@Components/UI/Communicates/Messages/Default";


type ErrorMessageComponentProps = {
    messageText?: string
};


export const ErrorMessageComponent: React.FC<ErrorMessageComponentProps> = ({
    messageText
}): JSX.Element | null => {


    if (!messageText) return null;


    return (
        <DefaultMessageComponent messageText={messageText} messageType={`danger`} />
    );

};


export default ErrorMessageComponent;
